import { useEffect, useState } from 'react';
var useTimeout = function (ms, started) {
  if (ms === void 0) {
    ms = 0;
  }
  if (started === void 0) {
    started = true;
  }
  var _a = useState(false),
    ready = _a[0],
    setReady = _a[1];
  var _b = useState(ms / 1000),
    sRemaining = _b[0],
    setSRemaining = _b[1];
  var _c = useState(undefined),
    timeoutId = _c[0],
    setTimeoutId = _c[1];
  useEffect(function () {
    if (started) {
      setTimeoutId(setTimeout(function () {
        setReady(true);
      }, ms));
      var interval_1 = setInterval(function () {
        setSRemaining(function (remaining) {
          return remaining - 1;
        });
      }, 1000);
      return function () {
        clearTimeout(timeoutId);
        clearInterval(interval_1);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ms, started]);
  var reset = function () {
    clearTimeout(timeoutId);
    setTimeoutId(setTimeout(function () {
      setReady(true);
    }, ms));
    setSRemaining(ms / 1000);
  };
  return [ready, sRemaining, reset];
};
export default useTimeout;